import React, { Component } from 'react';
import Translator from '../../../core/i18n';
import { Log, Level, Logger, Display } from 'ng2-logger';
import CUserHomeCalendar from '../../../components/user-home-calendar/main';
import CUserMyCourses from '../../../components/user-my-courses/main';
import Submain from '../../../components/home-page-sub-content/submain';
const T = Translator.create();
const _logger = Log.create('Student/Main.tsx');

export class StudentHome extends React.Component<any> {

    constructor(props: any) {
        super(props);
    }

    public render() {
        return (
            <div >
                <div className="student-course area-course">
                    <div className="container-fluid" style={{background: '#f1f1f1' }}>
                        <div className="row">
                                <CUserMyCourses />
                                <CUserHomeCalendar />
                        </div>
                    </div>
                </div>
                <div className="container-fluid" style={{ padding: '1.25em 8%' }}>
                    <div className="row">
                        <Submain />
                    </div>
                </div>
            </div>
        );
    }
}
